export default __webpack_public_path__ + "static/icp-cat-banner2-d82a8e013bc2ff653e225fdcffc6bbf5.png";